import AiRobotSearch from '../ai-robot/src/search';

/* istanbul ignore next */
AiRobotSearch.install = function(Vue) {
  Vue.component(AiRobotSearch.name, AiRobotSearch);
};

export default AiRobotSearch;
